

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    addPlugins(config, 'org.openedx.frontend.layout.header_desktop_main_menu.v1', [
        {
          op: PLUGIN_OPERATIONS.Modify,
          widgetId: 'default_contents',
          fn: (widget) => {
              const { useIntl } = require('@edx/frontend-platform/i18n');
              const intl = useIntl();
              const { getConfig } = require('@edx/frontend-platform');
              widget.content.menu = [
                {
                  type: 'item',
                  href: `${getConfig().LMS_BASE_URL}/dashboard`,
                  content: intl.formatMessage({
                      id: 'header.links.courses',
                      defaultMessage: 'Courses',
                      description: 'Link to the learner course dashboard',
                  }),
                },
                {
                  type: 'item',
                  href: `https://edu.utec.edu.uy/cursos/`,
                  content: intl.formatMessage({
                      id: 'header.links.content.search',
                      defaultMessage: 'Discover New',
                      description: 'Link to the content search page',
                  }),
                },
                {
                  type: 'item',
                  href: 'https://edu.utec.edu.uy/about/',
                  content: intl.formatMessage({
                      id: 'header.about.utec', 
                      defaultMessage: 'About EDU', 
                      description: 'Link to the EDU about page',
                  }),
                }
          ];
          return widget;
            },
        }]);
    addPlugins(config, 'org.openedx.frontend.layout.header_mobile_main_menu.v1', [
        {
          op: PLUGIN_OPERATIONS.Modify,
          widgetId: 'default_contents',
          fn: (widget) => {
              const { useIntl } = require('@edx/frontend-platform/i18n');
              const intl = useIntl();
              const { getConfig } = require('@edx/frontend-platform');
              widget.content.menu = [
                {
                  type: 'item',
                  href: `${getConfig().LMS_BASE_URL}/dashboard`,
                  content: intl.formatMessage({
                      id: 'header.links.courses',
                      defaultMessage: 'Courses',
                      description: 'Link to the learner course dashboard',
                  }),
                },
                {
                  type: 'item',
                  href: `${getConfig().LMS_BASE_URL}/courses`,
                  content: intl.formatMessage({
                      id: 'header.links.content.search',
                      defaultMessage: 'Discover New',
                      description: 'Link to the content search page',
                  }),
                },
                {
                  type: 'item',
                  href: 'https://edu.utec.edu.uy/about/',
                  content: intl.formatMessage({
                      id: 'header.about.utec', 
                      defaultMessage: 'About EDU', 
                      description: 'Link to the EDU about page',
                  }),
                }
          ];
          return widget;
            },
        }]);
    addPlugins(config, 'org.openedx.frontend.layout.header_learning_help.v1', [
        {
          op: PLUGIN_OPERATIONS.Hide,
          widgetId: 'default_contents'
        }]);
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_header_actions.v1', [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'chatbot',
            type: DIRECT_PLUGIN,
            RenderWidget: () => {
              const { useEffect } = require('react');
              useEffect(() => {
                const scriptId = 'utec-chatbot-script';
                if (!document.getElementById(scriptId)) {
                  const script = document.createElement('script');
                  script.id = scriptId;
                  script.src = "https://taa.utec.edu.uy/wp-content/bot-admin/chatbot-widget-with-botid.js?botId=959b89d4-b63f-4c9d-8ca2-9deb6fca23fa";
                  script.async = true;
                  document.body.appendChild(script);
                }
              }, []);
            }
          },
        }]);
    }
    if (process.env.APP_ID == 'account') {
      addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'chatbot',
            type: DIRECT_PLUGIN,
            RenderWidget: () => {
              const { useEffect } = require('react');
              useEffect(() => {
                const scriptId = 'utec-chatbot-script';
                if (!document.getElementById(scriptId)) {
                  const script = document.createElement('script');
                  script.id = scriptId;
                  script.src = "https://taa.utec.edu.uy/wp-content/bot-admin/chatbot-widget-with-botid.js?botId=959b89d4-b63f-4c9d-8ca2-9deb6fca23fa";
                  script.async = true;
                  document.body.appendChild(script);
                }
              }, []);
            }
          },
        }]);
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
      addPlugins(config, 'org.openedx.frontend.learner_dashboard.course_card_action.v1', [
        {
          op: PLUGIN_OPERATIONS.Hide,
          widgetId: 'default_contents'
        }]);
      addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'chatbot',
            type: DIRECT_PLUGIN,
            RenderWidget: () => {
              const { useEffect } = require('react');
              useEffect(() => {
                const scriptId = 'utec-chatbot-script';
                if (!document.getElementById(scriptId)) {
                  const script = document.createElement('script');
                  script.id = scriptId;
                  script.src = "https://taa.utec.edu.uy/wp-content/bot-admin/chatbot-widget-with-botid.js?botId=959b89d4-b63f-4c9d-8ca2-9deb6fca23fa";
                  script.async = true;
                  document.body.appendChild(script);
                }
              }, []);
            }
          },
        }]);
    }
    if (process.env.APP_ID == 'learning') {
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
      addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'chatbot',
            type: DIRECT_PLUGIN,
            RenderWidget: () => {
              const { useEffect } = require('react');
              useEffect(() => {
                const scriptId = 'utec-chatbot-script';
                if (!document.getElementById(scriptId)) {
                  const script = document.createElement('script');
                  script.id = scriptId;
                  script.src = "https://taa.utec.edu.uy/wp-content/bot-admin/chatbot-widget-with-botid.js?botId=959b89d4-b63f-4c9d-8ca2-9deb6fca23fa";
                  script.async = true;
                  document.body.appendChild(script);
                }
              }, []);
            }
          },
        }]);
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;